import { useMemo, useSyncExternalStore } from 'react';
import type { LobbySession } from './LobbySession.js';
import type { RoleRevealView, GhostGuessingView, GuessRevealView } from '../discussion/types.js';

export interface UseRevealSessionResult {
  /** Non-null iff phase === RoleReveal. */
  roleReveal: RoleRevealView | null;
  /** Non-null iff phase === GhostGuessing. */
  ghostGuessing: GhostGuessingView | null;
  /** Non-null iff phase === GuessReveal. */
  guessReveal: GuessRevealView | null;
  /** Only ever invoked on the guessing Ghost's own view. */
  onSubmitGuess: (word: string) => void;
}

export function useRevealSession(session: LobbySession): UseRevealSessionResult {
  const snapshot = useSyncExternalStore(
    (cb) => session.subscribe(cb),
    () => session.getSnapshot(),
  );
  const onSubmitGuess = useMemo(
    () => (word: string) => session.sendSubmitGuess(word),
    [session],
  );
  return {
    roleReveal: snapshot.roleRevealView,
    ghostGuessing: snapshot.ghostGuessingView,
    guessReveal: snapshot.guessRevealView,
    onSubmitGuess,
  };
}
